/**
 * `<app-toolbar>` — Shared toolbar for all main views inside the sidebar inset.
 *
 * Always renders a `<dui-sidebar-trigger>` followed by a default slot for
 * additional content (e.g. breadcrumbs).
 */

import { css, html, LitElement, type TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { base } from "../../design-system/index.ts";
import "../dui/sidebar/dui-sidebar-trigger.ts";

@customElement("app-toolbar")
export class AppToolbarElement extends LitElement {
  static override styles = [
    base,
    css`
      :host {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--space-2);
        height: var(--space-14);
        padding: var(--space-2) var(--space-4) var(--space-2) var(--space-2);
      }

      slot:not([name]) {
        display: block;
        flex: 1;
        min-width: 0;
        overflow: hidden;
      }
    `,
  ];

  override render(): TemplateResult {
    return html`
      <dui-sidebar-trigger></dui-sidebar-trigger>
      <slot></slot>
      <slot name="end"></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "app-toolbar": AppToolbarElement;
  }
}
